module.exports = __webpack_public_path__ + "img/1080_14.8e453c18.jpg";